import DataTable, { ErrorTypeStr } from "../components/ui/data-table";
export default DataTable;
export var ErrorTypeEnum = ErrorTypeStr;